import { ChannelUnsubscribe, channelClient, channelServer } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { authSessionContract } from './authSessionContract';

/** The session as the app's tabs share it. */
export const authSessionClient = {
  announceSessionRestored(): void {
    channelServer.publish(authSessionContract, DomainMessagesTypes.sessionRestored, undefined);
  },

  onSessionRestored(handler: () => void): ChannelUnsubscribe {
    return channelClient.onEventOfType(authSessionContract, DomainMessagesTypes.sessionRestored, () => handler());
  },
};
